export { ComparisonTable } from './ComparisonTable';
export type {
  ComparisonTableProps,
  ComparisonTableApi,
  ComparisonItem,
  ComparisonRowDef,
  ComparisonColumn,
  ComparisonEmptySlot,
  ComparisonCellValue,
  TextCellValue,
  BadgeListCellValue,
  DualTextCellValue,
  BadgeValue,
} from './types';
